import { Button } from "@mui/material";

function SaveChangingsButton({ children, alignSelf = "start", mt = "18px", onClick }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        alignSelf: alignSelf,
        borderRadius: "28px",
        px: "20px",
        minWidth: "auto",
        width: "auto",
        textTransform: "none",
        bgcolor: "#000000",
        color: "#FFFFFF",
        boxShadow: "none",
        py: "8px",
        mt: mt,
        "&:hover": {
          backgroundColor: "#000000",
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: "#000000",
          boxShadow: "none",
        },
        "&:focus": {
          outline: "none",
          boxshadow: "none",
        },
        "& .MuiButtonBase-root": {
          width: "auto !important",
          minWidth: "0px !important",
          padding: "0px",
          boxshadow: "none",
        },
      }}
    >
      {children}
    </Button>
  );
}

export default SaveChangingsButton;
